module.exports = __webpack_public_path__ + "img/account--icon.38be0e37.svg";